import Vue from 'vue'
import VueResource from 'vue-resource'
import { MessageBox } from 'element-ui'
import { getCookie, addCookie, deleteCookie } from '@/common/js/cookies'
import { loadFromLocal } from '@/common/js/store'
// import routes from '@/router'
// import VueRouter from 'vue-router'

Vue.use(VueResource)
// Vue.use(VueRouter)
// const router = new VueRouter({
//   mode: 'history',
//   routes
// })
// var root = process.env.API_ROOT;
// 将request body以application/x-www-form-urlencoded content type发送
// Vue.http.options.emulateJSON = true;
// 发送PUT, PATCH, DELETE请求时以HTTP POST的方式发送，并设置请求头的X-HTTP-Method-Override
Vue.http.options.emulateHTTP = true;
// Vue.http.options.headers = {
//   'Content-Type': 'application/json; charset=UTF-8',
//   'Accept': 'application/json, text/plain, */*'
// }
// 请求拦截器
Vue.http.interceptors.push((request, next) => {
  // ...
  // 请求发送前的处理逻辑
  // ...
  if (loadFromLocal('token')) {
    if (!request.params) {
      request.params = {}
    }
    request.params['access-token'] = loadFromLocal('token')
    // request.params['access-token'] = 'cXACbfqyizcbpcKF84DvOa5TTCIFkVJI'
  }
  if (request.method === 'POST') {
    if (request.url === '/_data/user/upload') {
      request.headers.set('content-type', 'multipart/form-data')
    }
  }
  request.credentials = true
  // console.log(request, window.location)
  next((response) => {
    // ...
    // 请求发送后的处理逻辑
    // ...
    // 根据请求的状态，response参数会返回给successCallback或errorCallback
    // console.log(response)
    if (response.body.errcode) {
      if (response.body.errcode === 2) { // 2是列表数据为空
        return
      }
      if (response.body.errcode === 401) { // 登录超时，请重新登录
        deleteCookie('isLogined')
        // window.location.reload()
        MessageBox.alert('请重新登录', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            if(window.Router){
              window.Router.replace({
                  path: '/',
                  // query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
              })
            }
          }
        })
      } else if (response.body.errcode === 14003) {  // 账号禁用
        deleteCookie('isLogined')
        MessageBox.alert(response.body.errmsg, '温馨提示', {
          confirmButtonText: '确定'
          // callback: action => { window.location.reload() }
        })
      } else {
        // window.alert(response.body.errmsg)
        MessageBox.alert(response.body.errmsg, '温馨提示', {
          confirmButtonText: '确定'
        })
      }
    }
  })
})

// 配置API接口地址
var root = '/_data'
// 使用Vue.resource全局方式访问接口
export default {
  getApiUrl(url) {
    return root + '/' + url;
  },
  createResource(url, param_defaults, actions) {
    // addCookie('token', 112, 0.01)
    // setStore('value', '22')
    let inner_actions = {
      get: { method: 'GET', url: this.getApiUrl(url) },
      query: { method: 'GET', isArray: true },
      update: { method: 'PUT', url: this.getApiUrl(url) },
      remove: { method: 'DELETE', url: this.getApiUrl(url) },
      delete: { method: 'DELETE', url: this.getApiUrl(url) },
    };
    let inner_param_defaults = {};
    // if (getCookie('token')) {
    //   inner_param_defaults.PHPSESSID = getCookie('token');
    // }
    for(let x in actions){
      if (!actions[x].url.includes(root)) {
        actions[x].url = this.getApiUrl(actions[x].url)
      }
    }
    actions = Object.assign(inner_actions, actions);
    param_defaults = Object.assign(inner_param_defaults, param_defaults);
    return Vue.resource(this.getApiUrl(url), param_defaults, actions);
  }
}



// WEBPACK FOOTER //
// ./config/api.js